<template>
  <div>
    <tabs />
    <v-container fluid>
      <div class="px-5">
<!--        <v-row>-->
<!--          <v-col class="py-0">-->
<!--            <marqueee></marqueee>-->
<!--          </v-col>-->
<!--        </v-row>-->

        <v-row>
          <v-col class="d-block d-md-none pb-0" cols="12">
            <div class="px-3">
              <sudden-death-widget-two></sudden-death-widget-two>
            </div>
          </v-col>

          <v-col cols="12" md="6" lg="7" xl="8">
            <home-fixtures-box></home-fixtures-box>
          </v-col>

          <v-col class="pt-0" cols="12" md="6" lg="5" xl="4">
            <div class="pr-3">
              <v-row class="d-none d-md-block" v-if="settings_sd_switch">
                <v-col>
                  <sudden-death-widget-two></sudden-death-widget-two>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="6" class="pt-0">
                  <div class="pr-0 pr-sm-1 pl-3 pl-md-0">
                    <weekly-scores-widget></weekly-scores-widget>
                  </div>
                </v-col>

                <v-col cols="12" sm="6" class="pt-0">
                  <div class="pl-3 pl-sm-1">
                    <league-widget></league-widget>
                  </div>
                </v-col>
              </v-row>

              <!-- <v-row>
                <v-col cols="12" sm="6" class="pt-0">
                  <div class="pr-0 pr-sm-1 pl-3 pl-md-0">
                    <form-6-widget></form-6-widget>
                  </div>
                </v-col>
                
                <v-col cols="12" sm="6" class="pt-0">
                  <div class="pl-3 pl-sm-1">
                    
                  </div>
                </v-col>
              </v-row> -->
            </div>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>

<script>
import Tabs from "@/components/Tabs";
import SuddenDeathWidgetTwo from "@/components/SuddenDeathWidgetTwo";
import LeagueWidget from "@/components/LeagueWidget";
import WeeklyScoresWidget from "@/components/WeeklyScoresWidget";
import Form6Widget from "@/components/Form6Widget";
import HomeFixturesBox from "../components/HomeFixturesBox.vue";
import Marqueee from "../components/Marquee.vue";
import { mapGetters } from "vuex";

export default {
  name: "Home",
  components: {
    Tabs,
    HomeFixturesBox,
    Marqueee,
    SuddenDeathWidgetTwo,
    LeagueWidget,
    WeeklyScoresWidget,
    Form6Widget,
  },
  data: () => ({}),
  computed: {
    ...mapGetters([
      "weekInfo",
      "weeks",
      "user",
      "settings_sd_switch",
      "currentSeasonSDGames",
      "latest_completed_week",
    ]),
    maxPlayWeek() {
      if (this.maxGameWeek && this.weeks) {
        return this.weeks.find((week) => week.id === this.maxGameWeek)
          .play_week_num;
      }
    },
    weekNumId() {
      if (this.weeks) {
        return this.weeks.find((week) => week.play_week_num === this.weekNum)
          .id;
      }
    },
  },
  methods: {
    //
  },
  created() {
    if (!this.currentSeasonSDGames) {
      this.$store.dispatch("getCurrentSeasonSdGames");
    }

    if (this.latest_completed_week) {
      this.show_marquee = true;
    } else {
      this.$store.dispatch("getLatestCompletedWeek");
    }
  },
  watch: {
    latest_completed_week(newVal, oldVal) {
      if (newVal.id) {
        this.show_marquee = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#sd-widget {
  border: 2px solid var(--v-secondary-base);
  background-color: #efebe9;
  // border-radius: 10px;
}

#home-week-tabs {
  font-family: "Barlow-SemiBold";
}
</style>
